import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    TimepickerModule, ModalModule, TabsModule, AccordionModule,
    ButtonsModule, BsDropdownModule
} from 'ng2-bootstrap/index';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Ng2GoogleChartsModule} from 'ng2-google-charts/index';
import {CheckboxModule, SliderModule} from 'primeng/primeng';
import {ClientFormsModule} from '../client-forms/client-forms.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ClientContactsService} from '../../models/client-contacts/client-contacts.service';
import {ClientVolumesService} from '../../models/client-volumes/client-volumes.service';
import {UnderwritingService} from '../../models/underwriting/underwriting.service';
import {SalesNotesService} from '../../models/sales-notes/sales-notes.service';
import {NoteCommentsService} from '../../models/note-comments/note-comments.service';
import {DebtAccountComponent} from './debt-account.component';
import {routing} from './debt-account.routes';
import {DebtsService} from '../../models/debts/debts.service';
import {PipesModule} from '../../pipes/pipes.module';
import {ClientAccountsService} from '../../models/client-accounts/client-accounts.service';
import {InvoiceModalComponent} from './invoice-modal/invoice-modal.component';
import {ProcessingItemComponent} from '../../views/accounting/processing/item/processing-item.component';
import {ProcessingModule} from '../../views/accounting/processing/processing.module';
import {ManagePaymentsModalComponent} from './manage-payments-modal/manage-payments-modal.component';
import {VoidModalComponent} from './void-modal/void-modal.component';
import {RemoveModalComponent} from './remove-modal/remove-modal.component';
import {DatepickerModule} from '../../directives/datepicker/datepicker.module';
import {ProcessorsService} from '../../models/processors/processors.service';
import {CloseDebtAccountModalComponent} from "./close-debt-account/close-debt-account.component";
import {SelectStatementsModalComponent} from "./select-statements/component";


@NgModule({
    entryComponents: [
        InvoiceModalComponent,
        ManagePaymentsModalComponent,
        VoidModalComponent,
        RemoveModalComponent,
        CloseDebtAccountModalComponent,
        SelectStatementsModalComponent
    ],
    exports: [
        DebtAccountComponent
    ],
    imports: [
        TimepickerModule.forRoot(),
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        CheckboxModule,
        TabsModule,
        // routing,
        PipesModule,
        Ng2GoogleChartsModule,
        AccordionModule.forRoot(),
        ButtonsModule.forRoot(),
        BsDropdownModule.forRoot(),
        CommonModule,
        ClientFormsModule,
        SliderModule,
        NgbModule.forRoot(),
        ProcessingModule,
        DatepickerModule
    ],
    declarations: [
        InvoiceModalComponent,
        DebtAccountComponent,
        ManagePaymentsModalComponent,
        VoidModalComponent,
        RemoveModalComponent,
        CloseDebtAccountModalComponent,
        SelectStatementsModalComponent
    ],
    providers: [
        ClientContactsService,
        ClientVolumesService,
        UnderwritingService,
        SalesNotesService,
        NoteCommentsService,
        DebtsService,
        ClientAccountsService,
        ProcessorsService
    ]
})

export class DebtAccountModule {

}


// WEBPACK FOOTER //
// ./src/app/modules/debt-account/debt-account.module.ts